import React, { FC } from 'react';
import { AnalyticsUsersFeedbackProps } from './AnalyticsUsersFeedbackProps';
import { BarChartPro } from '@mui/x-charts-pro/BarChartPro';
import AnalyticsLoader from '../AnalyticsLoader';

const AnalyticsUsersFeedback: FC<AnalyticsUsersFeedbackProps> = ({
  data,
  loading,
}) => {
  const dataset = data as any[];

  return (
    <AnalyticsLoader loading={loading}>
      <BarChartPro
        dataset={dataset}
        xAxis={[
          {
            scaleType: 'band',
            data: dataset.map((dataPiece) => dataPiece.date),
            tickLabelStyle: { angle: -45 },
          },
        ]}
        yAxis={[
          {
            dataKey: 'rating',
          },
        ]}
        series={[
          {
            dataKey: 'rating',
            valueFormatter: (value, context) => {
              const count = dataset[context.dataIndex]?.count || '';
              return `${value}% (${count} votes)`;
            },
          },
        ]}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsUsersFeedback;
